import React, { Component } from 'react'
import { MainContainer } from './MainContainer/MainContainer'

class App extends Component {
  render() {
    return <MainContainer />
  }
}

export default App
